module.exports = __webpack_public_path__ + "static/media/SY.7e1ac527.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/SY.svg
// module id = 367
// module chunks = 0